var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#25AE88"
    },
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBCE9D"
    },
    d: "M52.932,45.376C52.275,38.985,46.876,34,40.311,34h-5.946C33.611,34,33,33.389,33,32.635V31.99 c0-0.583,0.379-1.082,0.925-1.287c5.804-2.182,9.778-11.704,8.971-18.433C42.134,5.919,36.97,0.801,30.614,0.09 c-0.517-0.058-1.029-0.086-1.535-0.088c-0.016,0-0.032-0.001-0.048-0.001C21.285-0.016,15,6.258,15,14 c0,6.024,3.807,14.755,9.145,16.729C24.668,30.922,25,31.442,25,32v0.635C25,33.389,24.389,34,23.635,34h-5.946 c-6.565,0-11.964,4.985-12.621,11.376C10.293,52.998,19.061,58,29,58S47.707,52.998,52.932,45.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B5B4B"
    },
    d: "M33.492,6.61c3.715,1.021,7.213,3.306,9.453,6.322c-0.016-0.221-0.023-0.447-0.049-0.663 C42.134,5.919,36.97,0.801,30.614,0.09c-0.517-0.058-1.029-0.086-1.535-0.088c-0.016,0-0.032-0.001-0.048-0.001 c-6.92-0.015-12.66,4.995-13.808,11.583l0.005,0c0.179,0.252,0.354,0.507,0.545,0.75c0.07-0.087,0.141-0.173,0.213-0.258 c2-2.38,5.341-2.931,8.183-1.671C25.034,10.787,25.992,11,27,11C29.942,11,32.456,9.182,33.492,6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M52.932,45.376C52.275,38.985,46.876,34,40.311,34H37l-8,8l-8-8h-3.311 c-6.565,0-11.964,4.985-12.621,11.376C10.293,52.998,19.061,58,29,58S47.707,52.998,52.932,45.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424A60"
    },
    d: "M43,54.392c0.685-0.379,1.35-0.789,2-1.22V47h-2V54.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424A60"
    },
    d: "M15,54.392V47h-2v6.172C13.65,53.603,14.315,54.013,15,54.392z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user-3.f03109e1d577981f8074c46a72a9c04f.svg";
export { ForwardRef as ReactComponent };